import moment from "moment";

const defaults = {
  COMPANY_NAME: "Best Coast Pairings",
  APP_NAME: "BCP",
  LABEL_GAMESYSTEM: "Game System",
  SITE_NAME: "Best Coast Pairings",
  SITE_DESCRIPTION: "Best Coast Pairings: Competitive events, made easier",
  GAMESYSTEM_IMAGE_W: 6,
  GAMESYSTEM_IMAGE_H: 1,
  SOCIALS: "{}",
  SYSTEM_IMAGES_CLOUDFRONT: "",
  SUPPORTS_EVENT_FORMAT_LABEL: "Format",
  STYLESHEET: "stylesheet1",
  HEADER_SOLFORGE_URL: "",
  COMPANY_SUPPORT_URL: "https://gestudio.zendesk.com/hc/en-us",
  COMPANY_SUPPORT_EMAIL: "support@bestcoastpairings.com",

  MANUFACTURER_GW: "Games Workshop",
  GAMESTORE_GW: "OlkMrRfxrN",
  MASTER_ORG: "SSlBJWBO2c", // dev

  DATADOG_SESSION_SAMPLE_RATE: 0,
  DATADOG_SESSION_REPLAY_SAMPLE_RATE: 0,
  DATADOG_LOGS_SAMPLE_RATE: 100,

  LEADERBOARDS: true,
  TIMER_OVERTIME_SECONDS: 600
};

export function getLegal() {
  const legalText = getEnvironmentVariable("LEGAL_TEXT");
  if (!legalText) return undefined;
  return legalText.replaceAll("{year}", moment().format("YYYY"));
}

export function showStats(isAdmin) {
  return isAdmin || (isBrand("bcp") && !isProd());
}

export function getCompanyFlag() {
  return getEnvironmentVariable("COMPANY_FLAG");
}

export function isBrand(flag) {
  return getCompanyFlag() === flag;
}

// Unplug Yourself and Bananagrams share UY platform behaviour. Defaults to on
// for those brands; SUPPORTS_UY_PLATFORM_FEATURES="true"/"false" overrides.
export function supportsUYPlatformFeatures() {
  const override = getEnvironmentVariable("SUPPORTS_UY_PLATFORM_FEATURES");
  if (override === "true") return true;
  if (override === "false") return false;
  return isBrand("uy") || isBrand("bananagrams");
}

// TODO: once REACT_APP_DEPLOY_STAGE is set explicitly in every Amplify
// environment, drop the AMPLIFY_BRANCH-derived fallback below.
export function getDeployStage() {
  let explicitStage = getEnvironmentVariable("DEPLOY_STAGE");
  if (explicitStage) {
    return explicitStage;
  }

  let branch = getEnvironmentVariable("AMPLIFY_BRANCH");
  if (branch === "testing" || branch === "testing-organizations-overhaul") {
    return "dev";
  }

  let derivedStage = branch?.slice(branch.lastIndexOf("-") + 1);
  return derivedStage === "gold" ? "prod" : derivedStage;
}

export function isDev() {
  return getDeployStage() === "dev";
}

export function isStaging() {
  return getDeployStage() === "staging";
}

export function isProd() {
  return getDeployStage() === "prod";
}

export function getEnvironmentVariable(suffix) {
  let value = undefined;
  if (window.location?.hostname === "localhost") {
    value = process.env[`REACT_APP_LOCAL_${suffix}`];
    if (value === "NOT SET") {
      value = undefined;
    } else if (value !== undefined) {
      return suffix === "API" ? value?.replace("/v1", "") : value;
    }
  }

  value = process.env[`REACT_APP_${suffix}`];
  if (value === undefined || value === "NOT SET") {
    return defaults[suffix];
  }

  return suffix === "API" ? value?.replace("/v1", "") : value;
}

// Amplify env vars are always strings, so `"1"` and `1` both return the number 1.
// Unset (getEnvironmentVariable already maps "NOT SET" to the table default), empty or non-numeric
// values return defaultValue (undefined if not given).
export function getNumericEnvironmentVariable(suffix, defaultValue) {
  const value = getEnvironmentVariable(suffix);
  if (value === undefined || value === null) return defaultValue;
  if (typeof value === "string" && value.trim() === "") return defaultValue;

  const numeric = Number(value);
  return Number.isFinite(numeric) ? numeric : defaultValue;
}
